export default "__VITE_ASSET__SgOl6dtr__"